<template>
  <div class="companyInfo">
    <el-row>
      <el-col :span="24">
        <span
          v-if="company"
          style="font-size: 24px"
          @click="copySome(company.company_name)"
        >
          {{ company.company_name }}
        </span>
        <span style="font-size: 20px" v-if="archives">
          （<span>档案号：</span> <span @click="copySome(archives)">{{ archives }}</span
          >）
        </span>
        <span style="font-size: 20px" v-else>
          （<span>档案号：</span> <span>空</span>）
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem">
      <el-col>
        <span v-if="editComNamePower">
          <el-popover placement="bottom" width="300" trigger="click" @hide="clearSelf">
            <el-input
              v-model.trim="comName"
              size="mini"
              placeholder="请输入公司名称"
            ></el-input>
            <div style="margin-top: 0.15rem; text-align: right">
              <el-button type="primary" size="mini" @click="editComName">保存</el-button>
            </div>
            <el-button type="success" @click="getComName" slot="reference" size="mini"
              >修改公司名称</el-button
            >
          </el-popover>
        </span>
        <span>
          <el-button type="primary" size="mini" @click="updateBusinessInfo"
            >更新工商信息</el-button
          >
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="批量更新工商信息"
            placement="top"
          >
          <el-button type="warning" icon="el-icon-refresh" circle size="mini" @click="updateBusinessInfo_all"></el-button>
          </el-tooltip> -->
        </span>
        <span>
          <el-button type="warning" size="mini" @click="updateBusinessInfo_all"
            >批量更新工商信息</el-button
          >
        </span>
        <span v-if="editInvoicePower">
          <el-button type="primary" size="mini" @click="updateInvoiceInfo(company)"
            >更新凭证 / 发票档案号信息</el-button
          >
        </span>
        <el-button type="primary" size="mini" @click="updateSelfCompany(company)"
          >标记自家公司</el-button
        >
        <!-- <span>
          <el-upload style="display:inline-block" action="api/compnay_com/import_share" :headers="headers"
            ref="uploadMutiple" :show-file-list="false" :on-success="importedReturn">
            <el-button type="success" size="mini">导入共享人</el-button>
          </el-upload>
        </span> -->
        <!-- <span>
          <el-button
            type="warning"
            size="mini"
            @click="updateBusinessInfoCreCode"
            >更新统一社会信用代码</el-button
          >
        </span> -->
      </el-col>
    </el-row>
    <el-tabs type="border-card" class="mt-10">
      <el-tab-pane label="工商信息">
        <el-row v-if="company" class="m-tab">
          <el-col :span="4" class="m-th">
            <el-tooltip content="所属园区" placement="top" :open-delay="500"
              ><span class="hide">所属园区</span></el-tooltip
            >
          </el-col>
          <el-col :span="20" class="m-td">
            <span>{{ company.address_park }}</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="资本类型" placement="top" :open-delay="500"
              ><span class="hide">资本类型</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.cap_types" placement="top" :open-delay="500">{{
              company.cap_types
            }}</el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="特殊行业" placement="top" :open-delay="500"
              ><span class="hide">特殊行业</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">{{ company.spe_ind }}</el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="统一社会信用代码" placement="top" :open-delay="500"
              ><span class="hide">统一社会信用代码</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.cre_code" placement="top" :open-delay="500">
              <span class="hide">{{ company.cre_code }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="注册资本" placement="top" :open-delay="500"
              ><span class="hide">注册资本</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.regCapital" placement="top" :open-delay="500">
              <span class="hide">{{ company.regCapital }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="企业法人" placement="top" :open-delay="500"
              ><span class="hide">企业法人</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.legaler" placement="top" :open-delay="500">
              <span class="hide">{{ company.legaler }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="联系方式" placement="top" :open-delay="500"
              ><span class="hide">联系方式</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip
              :content="company.legaler_contact"
              placement="top"
              :open-delay="500"
            >
              <span class="hide">{{ company.legaler_contact }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="公司类型" placement="top" :open-delay="500"
              ><span class="hide">公司类型</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip
              :content="company.company_types"
              placement="top"
              :open-delay="500"
            >
              <span class="hide">{{ company.company_types }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="小微企业" placement="top" :open-delay="500"
              ><span class="hide">小微企业</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <span class="hide">{{ isMicroEnt(company.isMicroEnt) }}</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="行业" placement="top" :open-delay="500"
              ><span class="hide">行业</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.trade" placement="top" :open-delay="500">
              <span class="hide">{{ company.trade }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="登记机关" placement="top" :open-delay="500"
              ><span class="hide">登记机关</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.reg_auth" placement="top" :open-delay="500">
              <span class="hide">{{ company.reg_auth }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="执照登记地址" placement="top" :open-delay="500"
              ><span class="hide">执照登记地址</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.reg_address" placement="top" :open-delay="500">
              <span class="hide">{{ company.reg_address }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="实际经营地址" placement="top" :open-delay="500"
              ><span class="hide">实际经营地址</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip
              :content="company.operate_address"
              placement="top"
              :open-delay="500"
            >
              <span class="hide">{{ company.operate_address }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="成立日期" placement="top" :open-delay="500"
              ><span class="hide">成立日期</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip
              :content="company.date_of_est ? company.date_of_est.substring(0, 10) : ''"
              placement="top"
              :open-delay="500"
            >
              <span class="hide">{{
                company.date_of_est ? company.date_of_est.substring(0, 10) : ""
              }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="人员规模" placement="top" :open-delay="500"
              ><span class="hide">人员规模</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <span class="hide">{{ company.company_scole }}</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="注册号" placement="top" :open-delay="500"
              ><span class="hide">注册号</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.regNumber" placement="top" :open-delay="500">
              <span class="hide">{{ company.regNumber }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="营业期限" placement="top" :open-delay="500"
              ><span class="hide">营业期限</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip
              :content="toTime(company.fromTime, company.toTime)"
              placement="top"
              :open-delay="500"
            >
              <span class="hide">{{ toTime(company.fromTime, company.toTime) }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="注册地址" placement="top" :open-delay="500"
              ><span class="hide">注册地址</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.regLocation" placement="top" :open-delay="500">
              <span class="hide">{{ company.regLocation }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="纳税人识别号" placement="top" :open-delay="500"
              ><span class="hide">纳税人识别号</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.taxNumber" placement="top" :open-delay="500">
              <span class="hide">{{ company.taxNumber }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="组织机构代码" placement="top" :open-delay="500"
              ><span class="hide">组织机构代码</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.orgNumber" placement="top" :open-delay="500">
              <span class="hide">{{ company.orgNumber }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="企业状态" placement="top" :open-delay="500"
              ><span class="hide">企业状态</span></el-tooltip
            >
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="company.regStatus" placement="top" :open-delay="500">
              <span class="hide">{{ company.regStatus }}</span>
            </el-tooltip>
          </el-col>
          <el-col :span="4" class="m-area-th">
            <el-tooltip content="经营范围" placement="top" :open-delay="500"
              ><span class="hide">经营范围</span></el-tooltip
            >
          </el-col>
          <el-col :span="20" class="m-area-td">
            <span>{{ company.bus_scope }}</span>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="服务人员">

        <company-multiple-server :cid="cid"></company-multiple-server>

        <!-- <el-table
          :data="companyServers"
          style="width: 100%"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{ background: '#ecf4ff',color: '#333',fontWeight: '900',fontSize: '0.28rem' }"
        >
          <el-table-column prop="role" label="角色" width="150"> </el-table-column>
          <el-table-column prop="username" label="姓名">
            <template slot-scope="scope">


              <div
                v-if="scope.row.role === '共享人'"
                class="tag-style"
              >
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag.id, cid, scope.row.role)"
                >
                  {{ tag.username }}
                </el-tag>
                <el-select
                  ref="saveTagInput"
                  v-if="inputVisible"
                  class="input-new-tag"
                  @focus="onBlur(scope.row.role)"
                  v-model="companyShare"
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                  @click.native="loadAdminAndShare(cid)"
                  @change="setShare($event, cid, scope.row.role)"
                >
                  <el-option
                    v-for="item in shareAdminuser"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button v-else class="button-new-tag" size="small" @click="showInput(scope.row.role)"
                  >+ 新增</el-button
                >
              </div>

              <div
                v-else-if="scope.row.role === '综合会计'"
                class="tag-style"
              >
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicGeneralAccountingTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag.id, cid, scope.row.role)"
                >
                  {{ tag.username }}
                </el-tag>
                <el-select
                  ref="saveGeneralAccountingTagInput"
                  v-if="inputGeneralAccountingVisible"
                  class="input-new-tag"
                  @focus="onBlur(scope.row.role)"
                  v-model="companyGeneralAccounting"
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                  @click.native="loadAdminAndShare(cid)"
                  @change="setShare($event, cid, scope.row.role)"
                >
                  <el-option
                    v-for="item in shareAdminuser"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput(scope.row.role)"
                  >+ 新增</el-button
                >
              </div>

              <div v-else-if="scope.row.role === '专属顾问'" class="tag-style">
                <company-multiple-server :cid="cid"></company-multiple-server>
              </div>

              <div
                v-else-if="scope.row.role === '财税转化'"
                class="tag-style"
              >
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicFinanceTransformTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag.id, cid, scope.row.role)"
                >
                  {{ tag.username }}
                </el-tag>
                <el-select
                  ref="saveFinanceTransformTagInput"
                  v-if="inputFinanceTransformVisible"
                  class="input-new-tag"
                  @focus="onBlur(scope.row.role)"
                  v-model="companyFinanceTransform"
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                  @click.native="loadAdminAndShare(cid)"
                  @change="setShare($event, cid, scope.row.role)"
                >
                  <el-option
                    v-for="item in shareAdminuser"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput(scope.row.role)"
                  >+ 新增</el-button
                >
              </div>

              <div
                v-else-if="scope.row.role === '工商许可'"
                style="white-space: nowrap; overflow: auto"
              >
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicBusinessLicenceTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag.id, cid, scope.row.role)"
                >
                  {{ tag.username }}
                </el-tag>
                <el-select
                  ref="saveBusinessLicenceTagInput"
                  v-if="inputBusinessLicenceVisible"
                  class="input-new-tag"
                  @focus="onBlur(scope.row.role)"
                  v-model="companyBusinessLicence"
                  multiple
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                  @click.native="loadAdminAndShare(cid)"
                  @change="setShare($event, cid, scope.row.role)"
                >
                  <el-option
                    v-for="item in shareAdminuser"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput(scope.row.role)"
                  >+ 新增</el-button
                >
              </div>

              <div v-else>
                <el-tooltip
                  effect="dark"
                  content="点击修改人员"
                  placement="top"
                  v-if="scope.row.username"
                >
                  <el-popover placement="left-start" width="200" trigger="click">
                    <el-select
                      v-model="chooseAdmin"
                      clearable
                      placeholder="选择人员"
                      size="mini"
                      filterable
                      @click.native="loadAdminAl(scope.row.id)"
                    >
                      <el-option
                        v-for="item in adminOptions"
                        :key="item.id"
                        :label="item.username"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <div
                      style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.16rem;
                      "
                    >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="saveChange(scope.row.field)"
                        >保存</el-button
                      >
                    </div>
                    <i
                      style="cursor: pointer"
                      slot="reference"
                      @click="loadAdminBefore(scope.row.id)"
                      >{{ scope.row.username }}</i
                    >
                  </el-popover>
                </el-tooltip>
                <el-tooltip effect="dark" content="添加人员" placement="top" v-else>
                  <el-popover placement="left-start" width="200" trigger="click">
                    <el-cascader
                      style="width: 100%"
                      v-model="chooseAdmin"
                      placeholder="选择人员"
                      :options="adminOptions"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      filterable
                      @click.native="loadAdmin"
                    >
                    </el-cascader>
                    <div
                      style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.16rem;
                      "
                    >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="saveChange(scope.row.field)"
                        >保存</el-button
                      >
                    </div>
                    <i
                      slot="reference"
                      class="el-icon-circle-plus-outline"
                      style="color: #409eff; font-size: 0.5rem; cursor: pointer"
                      @click="chooseAdmin = ''"
                    >
                      <span style="opacity: 0">+</span>
                    </i>
                  </el-popover>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table> -->

      </el-tab-pane>
      <el-tab-pane label="人员变更记录">
        <el-row>
          <el-timeline>
            <el-timeline-item
              v-for="log in logRecord"
              :key="log.id"
              :timestamp="log.created_at"
              placement="top"
            >
              <el-card>
                <p>{{ log.log_record }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="反馈记录">
        <feed-back
          :orderId="cid"
          :type="3"
          :isShow="false"
          :cType="checkType"
        ></feed-back>
      </el-tab-pane>
      <el-tab-pane label="网站信息" name="web">
        <resource-list-page-content :pageData="companyWebData" :cols="companyWebCols"  v-loading="webLoading"></resource-list-page-content>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="更新中..."
      :visible.sync="dialogProgress"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :wrapperClosable="false"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="creCodePer"
        status="success"
      ></el-progress>
    </el-dialog>
    <el-dialog
      title="更新凭证 / 发票档案号信息"
      :visible.sync="updateInvoiceDialog"
      :append-to-body="true"
      width="25%"
    >
      <div class="contents">
        <el-row style="margin-bottom: 0.2rem">
          <el-input
            size="mini"
            placeholder="请输入凭证档案号"
            v-model="editData.voucher_no"
            clearable
          >
          </el-input>
        </el-row>
        <el-row style="margin-bottom: 0.2rem">
          <el-input
            size="mini"
            placeholder="请输入发票档案号"
            v-model="editData.invoice_no"
            clearable
          >
          </el-input>
        </el-row>
        <el-row>
          <el-input
            size="mini"
            placeholder="请输入发票档案号备注"
            v-model="editData.invoice_no_remark"
            clearable
          >
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose()">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleDialogVisible()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="ShareImportInfo"
      append-to-body
      @closed="closeSelf"
    >
      <span slot="title" style="font-weight: bold; font-size: large; color: #409eff"
        >导入信息</span
      >
      <div class="import-info-style">
        <p style="color: #67c23a; font-size: medium">共成功导入{{ successNum }}条</p>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          公司名称未匹配{{ unCompanys.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col
              :span="6"
              v-for="item in unCompanys"
              :key="item"
              style="margin-bottom: 0.2rem"
            >
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div
                  style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <p style="color: #e6a23c; font-size: medium; margin-top: 0.2rem">
          后台用户名称未匹配{{ unAdminUsers.length }}条:
        </p>
        <div style="margin-top: 0.1rem">
          <el-row gutter="20">
            <el-col
              :span="6"
              v-for="item in unAdminUsers"
              :key="item"
              style="margin-bottom: 0.2rem"
            >
              <el-tooltip class="item" effect="dark" :content="item" placement="top">
                <div
                  style="
                    width: 225px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item }}
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import FeedBack from "common/FeedBack";
import CompanyMultipleServer from "common/CompanyMultipleServer";
import ResourceListPageContent from 'common/ResourceListPageContent'
// import CompanySingleServer from "common/CompanySingleServer";

export default {
  name: "CompanyInfo",
  props: {
    companyId: Number,
    checkType: {
      type: Number,
      default: 16,
    },
  },
  components: { FeedBack, CompanyMultipleServer, ResourceListPageContent },
  data() {
    return {
      // inputVisible: false,
      // inputGeneralAccountingVisible: false,
      // inputFinanceTransformVisible: false,
      // inputBusinessLicenceVisible: false,

      // companyShare: [],
      // companyGeneralAccounting: [],
      // companyFinanceTransform: [],
      // companyBusinessLicence: [],

      unCompanys: [],
      unAdminUsers: [],
      successNum: "",
      ShareImportInfo: false,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      creCodePer: 0,
      dialogProgress: false,
      totalCreCode: 0,
      company: [],
      chooseAdmin: "",
      adminOptions: [],
      archives: null,
      comName: "",
      editComNamePower: false,
      updateInvoiceDialog: false,
      editInvoicePower: false,
      editData: {
        voucher_no: "",
        invoice_no: "",
        invoice_no_remark: "",
      },
      cid: null,
      logRecord: [],
      // companyServers: [],
      // shareAdminuser: [],
      companyWebData: [],
      companyWebCols: [
        { label: '网站', prop: 'title', width: 120 },
        { label: '类型', prop: 'type' },
        { label: '状态', prop: 'status' },
        { label: '备案号', prop: 'bei_an', width: 180 },
        { label: '网址', prop: 'website', width: 180 },
        { label: '域名', prop: 'domain', width: 180 },
        { label: '审核日期', prop: 'check_date', width: 160 }
      ],
      webLoading: false
    };
  },
  watch: {
    companyId: function (val) {
      this.cid = val || null;
      this.company = [];
      // this.companyServers = [];
      if (val) this.getCompanyInfo(val);
      if (val) this.loadArchives(val);
      if (val) this.getCompanyWeb()

      // if (val) this.getServer(val);
      // if (val) this.loadAdminAndShare(val);
    },
  },
  computed: {
    // dynamicTags() {
    //   let arr = [];
    //   this.shareAdminuser.forEach((item) => {
    //     this.companyShare.forEach((i) => {
    //       if (item.id === i)
    //         arr.push({
    //           id: i,
    //           username: item.username,
    //         });
    //     });
    //   });
    //   return arr;
    // },
    // dynamicGeneralAccountingTags() {
    //   let arr = [];
    //   this.shareAdminuser.forEach((item) => {
    //     this.companyGeneralAccounting.forEach((i) => {
    //       if (item.id === i)
    //         arr.push({
    //           id: i,
    //           username: item.username,
    //         });
    //     });
    //   });
    //   return arr;
    // },
    // dynamicFinanceTransformTags() {
    //   let arr = [];
    //   this.shareAdminuser.forEach((item) => {
    //     this.companyFinanceTransform.forEach((i) => {
    //       if (item.id === i)
    //         arr.push({
    //           id: i,
    //           username: item.username,
    //         });
    //     });
    //   });
    //   return arr;
    // },
    // dynamicBusinessLicenceTags() {
    //   let arr = [];
    //   this.shareAdminuser.forEach((item) => {
    //     this.companyBusinessLicence.forEach((i) => {
    //       if (item.id === i)
    //         arr.push({
    //           id: i,
    //           username: item.username,
    //         });
    //     });
    //   });
    //   return arr;
    // },
  },
  methods: {
    // onBlur(role) {
    //   const inputRefs = {
    //     '共享人': 'saveTagInput',
    //     '综合会计': 'saveGeneralAccountingTagInput',
    //     '财税转化': 'saveFinanceTransformTagInput',
    //     '工商许可': 'saveBusinessLicenceTagInput',
    //   };

    //   if (inputRefs[role]) {
    //     this.$refs[inputRefs[role]].$refs.input.blur = () => {
    //       this[`input${role.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())}Visible`] = false;
    //     };
    //   }
    // },
    // handleClose(id, cid, role) {
    //   let arr = [];
    //   const dynamicTags = {
    //     '共享人': this.dynamicTags,
    //     '综合会计': this.dynamicGeneralAccountingTags,
    //     '财税转化': this.dynamicFinanceTransformTags,
    //     '工商许可': this.dynamicBusinessLicenceTags,
    //   };
    //   if (dynamicTags[role]) {
    //     dynamicTags[role].forEach((item) => {
    //       if (item.id !== id) arr.push(item.id);
    //     });
    //   }
    //   this.$nextTick(() => {
    //       this.setShare(arr, cid, role);
    //     });
    // },
    // showInput(role) {
    //   if (role === '共享人') {
    //     this.inputVisible = true;
    //     this.$nextTick((_) => {
    //       this.$refs.saveTagInput.$refs.input.focus();
    //     });
    //   } else if (role === '综合会计') {
    //     this.inputGeneralAccountingVisible = true;
    //     this.$nextTick((_) => {
    //       this.$refs.saveGeneralAccountingTagInput.$refs.input.focus();
    //     });
    //   } else if (role === '财税转化') {
    //     this.inputFinanceTransformVisible = true;
    //     this.$nextTick((_) => {
    //       this.$refs.saveFinanceTransformTagInput.$refs.input.focus();
    //     });
    //   } else if (role === '工商许可') {
    //     this.inputBusinessLicenceVisible = true;
    //     this.$nextTick((_) => {
    //       this.$refs.saveBusinessLicenceTagInput.$refs.input.focus();
    //     });
    //   }
    // },
    // setShare(val, cid, role) {
    //   var keyword = '';
    //   const keywords = {
    //     '共享人': 'shares',
    //     '综合会计': 'general_accounting',
    //     '财税转化': 'finance_transform',
    //     '工商许可': 'business_licence',
    //   };
    //   keyword = keywords[role];
    //   this.$axios
    //     .post("api/compnay_com/set_share", {
    //       company_id: cid,
    //       [keyword]: val,
    //       role: role
    //     })
    //     .then(({ data }) => {
    //       if (data.code === 1) {
    //         if (this.cid) {
    //           this.loadAdminAndShare(this.cid);
    //         }
    //         this.resetInputVisibility();
    //         this.$message.success(data.msg);
    //       }
    //     })
    //     .catch();
    // },
    // resetInputVisibility() {
    //   this.inputVisible = false;
    //   this.inputGeneralAccountingVisible = false;
    //   this.inputFinanceTransformVisible = false;
    //   this.inputBusinessLicenceVisible = false;
    // },
    // loadAdminAndShare(val) {
    //   this.$axios
    //     .get("api/compnay_com/get_adminuser_share", {
    //       params: {
    //         company_id: val,
    //       },
    //     })
    //     .then(({ data }) => {
    //       if (data.code === 1) {
    //         this.shareAdminuser = data.data.adminUser;
    //         this.companyGeneralAccounting = data.data.generalAccounting;
    //         this.companyFinanceTransform = data.data.financeTransform;
    //         this.companyBusinessLicence = data.data.businessLicence;
    //         this.companyShare = data.data.share;
    //       }
    //     })
    //     .catch();
    // },
    closeSelf() {
      this.unCompanys = [];
      this.unAdminUsers = [];
      this.successNum = "";
    },
    importedReturn(res) {
      if (res.code === 1) {
        this.unCompanys = res.data.unCompanys;
        this.unAdminUsers = res.data.unAdminUsers;
        this.successNum = res.data.success;
        this.ShareImportInfo = true;
      }
    },
    updateBusinessInfoCreCode() {
      this.$axios.get("api/comcom/update_business_info_cre_code").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          // this.getCompanyInfo(this.companyId)
          this.$message.success("共更新了" + data.data + "条数据！");
          // this.totalCreCode += data.data
          // this.creCodePer += 10
          // if (data.data !== 0) {
          //   this.updateBusinessInfoCreCode()
          //   return false
          // }
          // this.$message.success('共更新了' + this.totalCreCode + '条数据！')
          // this.creCodePer = 100
          // this.dialogProgress = false
          // this.creCodePer = 0
          // this.totalCreCode = 0
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    updateBusinessInfo() {
      this.$axios
        .put("api/comcom/update_business_info", {
          companyName: this.company.company_name,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.$nextTick(() => {
              this.getCompanyInfo(this.companyId);
            });
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    updateBusinessInfo_all() {
      this.$axios.get("api/comcom/update_all_business_info").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.$message.success("本次共更新了" + data.data + "条数据！");
        } else {
          this.$message.warning(data.msg);
        }
      });
    },
    // 更新当前公司为自家公司
    updateSelfCompany(company) {
      this.$confirm("确定标记该公司为自家公司吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("api/admin/update/update_company_flag", {
              company: company,
            })
            .then(({ data }) => {
              if (data.code === 0) {
                this.$emit("reloadTable");
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 更新凭证、发票档案号
    updateInvoiceInfo(company) {
      this.updateInvoiceDialog = true;
      this.editData.voucher_no = company.voucher_no;
      this.editData.invoice_no = company.invoice_no;
      this.editData.invoice_no_remark = company.invoice_no_remark;
    },
    HandleDialogVisibleClose() {
      this.updateInvoiceDialog = false;
    },
    HandleDialogVisible() {
      this.$axios
        .post("api/comcom/update_invoice_info", {
          params: {
            voucherNo: this.editData.voucher_no,
            invoiceNo: this.editData.invoice_no,
            invoiceNoRemark: this.editData.invoice_no_remark,
            companyId: this.companyId,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.updateInvoiceDialog = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    ifEdit() {
      this.$axios.get("api/comcom/if_edit").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.editComNamePower = data.data;
        }
      });
    },
    ifEditInvoicePower() {
      this.$axios.get("api/comcom/if_edit_invoice").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.editInvoicePower = data.data;
        }
      });
    },
    getComName() {
      this.comName = this.company.company_name;
    },
    clearSelf() {
      this.comName = "";
    },
    editComName() {
      if (this.comName) {
        this.$axios
          .put("api/comcom/edit_comname", {
            companyId: this.companyId,
            comName: this.comName,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              var myEvent = new Event("click");
              document.dispatchEvent(myEvent);
              this.company.company_name = data.data;
              this.$emit("reloadTable");
              this.$message.success(data.msg);
              this.comName = "";
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    getCompanyInfo(cid) {
      this.$axios.get("/api/admin/companies/info/" + cid).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.company = data.data.myCompany;
          this.logRecord = data.data.logRecord;
        }
      });
    },
    getServer(val) {
      this.$axios.get("api/quains/getserver?company_id=" + val).then((res) => {
        let { data } = res;
        if (data.code === 1) {
          this.companyServers = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    isMicroEnt(val) {
      let str = "";
      if (val === 1) str = "是";
      if (val === 0) str = "否";

      return str;
    },
    toTime(from, to) {
      let time = "";
      if (from) {
        let toTime = to || "无固定期限";
        time = from + " 至 " + toTime;
      }

      return time;
    },
    loadAdmin() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminOptions = data.data;
          }
        })
        .catch();
    },
    loadAdminAl(id) {
      // this.chooseAdmin = Number(id)
    },
    saveChange(field) {
      this.$axios
        .put("api/schedulebody/savechange", {
          companyId: this.companyId,
          role: field,
          user: this.chooseAdmin,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            var myEvent = new Event("click");
            document.dispatchEvent(myEvent);
            this.$message.success(data.msg);
            this.getServer(this.companyId);
            this.chooseAdmin = "";
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    loadAdminBefore(id) {
      this.$axios
        .get("api/expmanage/getreceiver")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminOptions = data.data;
            this.chooseAdmin = Number(id);
          }
        })
        .catch();
    },
    loadArchives(id) {
      this.$axios
        .get("api/servicein/archives?company_id=" + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.archives = data.data;
          }
        })
        .catch();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getCompanyWeb () {
      this.webLoading = true
      this.$axios.get('/api/admin/company/webs?cid=' + this.companyId, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyWebData = data.data.data
            this.webLoading = false
          }
        })
    }
  },
  mounted() {
    this.ifEdit();
    this.ifEditInvoicePower();
  },
};
</script>

<style lang="stylus" scoped>
.companyInfo {
  font-size: 12px;

  .hide {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mt-10 {
    margin-top: 0.2rem;
  }

  .m-tab {
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
  }

  .m-th {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-bottom: 1px solid #dee2e6;
    color: #909399;
    background: #fafafa;
  }

  .m-td {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }

  .m-area-th {
    padding: 0 5px;
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #dee2e6;
    color: #909399;
    background: #fafafa;
  }

  .m-area-td {
    padding: 5px 5px;
    height: 80px;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    overflow-y: auto;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .tag-style {
    white-space: nowrap;
    overflow: auto
  }
}
</style>



// WEBPACK FOOTER //
// src/common/CompanyInfo.vue